const calendarEN = {
	loading: "Loading your schedule...",
	title: "My Calendar",
	break: "break",

	sub: {
		adjusting: "Adjust your base working hours",
		default: "Click inside an hour to add a personal event",
	},

	toolbar: {
		thisWeek: "This Week",
		today: "Today",
		closeEditor: "Close Schedule Editor",
		editSchedule: "Staff Schedule",
		day: "Show Day",
		week: "Show Week",
		blockTime: "Close Time Slot",
	},

	editSchedule: "Staff Schedule",
	addWalkIn: "Add Walk In",

	editor: {
		title: "Weekly Working Hours",
		subtitle: "Toggle open days and adjust start / end times.",

		hours: "Working Hours",
		breaks: "Breaks",

		closed: "Closed",
		cancel: "Cancel",
		save: "Save",
		saving: "Saving...",
	},

	breaks: {
		title: "Recurring Breaks",
		subtitle: "Add lunch or rest periods that repeat weekly.",
		add: "+ Add Break",
	},

	popup: {
		addEventTitle: "Add Personal Event",
		title: "Title",
		placeholderTitle: "e.g. Lunch with client",
		start: "Start",
		end: "End",
		description: "Description",
		placeholderDesc: "Add notes or details...",
		cancel: "Cancel",
		addEvent: "Add Event",
	},

	details: {
		noDescription: "No description provided",
		close: "Close",

		services: "Services",
		reassignLabel: "Reassign to Staff Member",
		noAvailableStaff: "No available staff for this time slot.",
		selectStaff: "Select staff…",
		reassign: "Reassign",
		cancelBooking: "Cancel Booking",
	},

	empty: {
		noStaffWorking: "No staff are working today",
		updateHint: "Update staff schedules to show availability",

		noScheduleToday: "No schedule today",
		notWorking: "You are not working on this day",
	},

	walkin: {
		title: "Add Walk-In",
		close: "Close",

		timePeriods: {
			morning: "Morning",
			afternoon: "Afternoon",
			evening: "Evening",
		},

		noSlots: "No available slots for this period.",

		staff: {
			select: "Select staff",
		},

		service: {
			label: "Service",
			none: "No services attached to this staff. Configure services for the shop first.",
			placeholder: "Select a service",
		},

		duration: {
			label: "Duration",
			edit: "Edit",
			done: "Done",
			minutes: "min",
		},

		client: {
			label: "Client Name (optional)",
			placeholder: "Walk-In",
		},

		validation: {
			selectStaff: "Please select a staff member.",
			selectService: "Please select a service.",
			selectTime: "Please select a time slot.",
			pastTime: "You cannot create a walk-in in the past.",
		},

		footer: {
			noService: "No service selected",
			saving: "Saving...",
			confirm: "Add Walk-In",
		},

		toast: {
			success: "Walk-in added successfully",
			error: "Could not create walk-in. Please try again.",
		},
	},
	exclusion: {
		title: "Block Time / Vacation",

		startDate: "Start Date",
		endDate: "End Date",

		fullDay: "Full day(s)",
		fullDayLabel: "Full Day",

		startTime: "Start Time",
		endTime: "End Time",

		reasonLabel: "Reason (optional)",
		reasonPlaceholder: "Vacation, Off, Closed, etc.",

		existing: "Existing Blocked Times",

		save: "Save",
		saving: "Saving...",
		conflictsBanner: "You have {count} booking(s) in this range. Cancel or reassign them first.",
		overlapBanner: "This exclusion overlaps an existing one",
		reasonDefault: "Unavailable",

		toast: {
			saved: "Time blocked successfully",
			error: "Failed to block time",
			removed: "Removed",
			removeError: "Error removing exclusion",
		},
	},
};

export default calendarEN;
